import { __assign, __rest } from "tslib";
import React from 'react';
import { Platform, View } from 'react-native';
import Covid from '../../components/DisasterRelief/Covid';
import { BannerView, PnmacHtmlToNative, PnmacNavigation } from 'pnmac-universal-components';
import { TrackerActionLID_ENUM, TrackerCategoryLID_ENUM, TrackerHitTypeLID_ENUM, UserLanguage_ENUM } from '../../redux/events/events';
import { getActiveFeatures } from '../../utils';
export var BannerSection = function (_a) {
  var _b;
  var state = _a.state,
    matches = _a.matches,
    props = __rest(_a, ["state", "matches"]);
  var layout = props.layout,
    translations = props.translations,
    trackerDispatcher = props.trackerDispatcher;
  var dexpmessage = translations === null || translations === void 0 ? void 0 : translations[layout.DEXPMessagePennyContentKey];
  return /*#__PURE__*/React.createElement(React.Fragment, null, state.showBanner && !layout.mobile && layout.selectedLoanNumber !== 0 ? (/*#__PURE__*/React.createElement(View, null, /*#__PURE__*/React.createElement(Covid, __assign({
    matches: matches,
    inactive: state.inactive,
    movrWebStatus: state.movrWebStatus
  }, props)))) : state.showBanner && layout.selectedLoanNumber !== 0 && getActiveFeatures(layout.features, "show_movr_mobile", false) && (/*#__PURE__*/React.createElement(Covid, __assign({
    matches: matches,
    inactive: state.inactive,
    movrWebStatus: state.movrWebStatus
  }, props))), ((_b = layout.DEXPMessagePennyContentKey) === null || _b === void 0 ? void 0 : _b.length) > 1 && (/*#__PURE__*/React.createElement(View, {
    style: {
      paddingTop: 10
    }
  }, /*#__PURE__*/React.createElement(BannerView, {
    style: {
      marginHorizontal: 10
    }
  }, /*#__PURE__*/React.createElement(PnmacHtmlToNative, __assign({
    value: dexpmessage,
    onClick: function (e) {
      var target = e.target.toString();
      if (target != null && target.indexOf('/Account/ContactInformation') > -1) {
        trackerDispatcher(UserLanguage_ENUM.English, TrackerCategoryLID_ENUM.Button, TrackerHitTypeLID_ENUM.Event, TrackerActionLID_ENUM.Click, 'Account Setting Page ContactInformation Clicked', 0);
      }
    },
    navigation: {
      navigate: function () {
        trackerDispatcher(UserLanguage_ENUM.English, TrackerCategoryLID_ENUM.Button, TrackerHitTypeLID_ENUM.Event, TrackerActionLID_ENUM.Click, 'Account Setting Page ContactInformation Clicked', 0);
        PnmacNavigation(__assign({
          action: {
            pathname: "/Account"
          }
        }, props));
      }
    }
  }, props))))), (layout === null || layout === void 0 ? void 0 : layout.showComunicationPreferenceChangeBanner) && (/*#__PURE__*/React.createElement(View, {
    style: {
      paddingTop: 10
    }
  }, /*#__PURE__*/React.createElement(BannerView, {
    style: {
      marginHorizontal: 10
    }
  }, /*#__PURE__*/React.createElement(PnmacHtmlToNative, __assign({
    value: translations.CommunicationPreferenceBannerMessage
  }, props))))), state.showBanner && !layout.mobile && layout.selectedLoanNumber !== 0 && Platform.select({
    web: (/*#__PURE__*/React.createElement("hr", {
      style: {
        marginTop: 15,
        marginBottom: 15,
        marginLeft: 15,
        marginRight: 15
      }
    }))
  }));
};